import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import {
  GridHeader,
  ProductAttachments,
  Country,
  Authors,
  defaultProductAttachments,
  GridHeaderEx, 
  Category,
  ProductMaster
} from 'src/app/model';
import { Subscription } from 'rxjs';
import { SelectItem } from 'primeng/api';
import {
  MsgService
  , ProductAttachmentsService
  , UtilService
  , AppConfigService
} from 'src/app/service';

@Component({
  selector: 'app-product-attachments',
  templateUrl: './product-attachments.component.html',
  styleUrls: ['./product-attachments.component.scss']
})
export class ProductAttachmentsComponent implements OnInit, OnDestroy {
  @ViewChild('catg_images', { static: true }) specDoc: ElementRef;
  private subscription = new Subscription();
  public cols: Array<GridHeader> = [];
  public dataArray: Array<ProductAttachments>;
  public selectedRows: Array<any> = [];
  public selectedColumns: Array<GridHeader>;
  public dataObj: ProductAttachments = defaultProductAttachments;
  public isDeleteDetails = false;
  public isAddDetails = false;
  public isEditDetails = false;
  public isViewDetails = false;
  public editCallTypeList: any = {};

  public trending: boolean = false;
  public popular: boolean = false;

  public ProductAttachmentsList: Array<SelectItem> = [];
  public selectedCountry: Country;

  public productsList: Array<SelectItem> = [];
  public selectedProduct: ProductMaster;

  public authorsList: Array<SelectItem> = [];
  public selectedAuthor: Authors;

  public categoriesList: Array<SelectItem> = [];
  public selectedCategory: Category;

  public trendingList: Array<SelectItem> = [];
  public selectedTrending: ProductAttachments;

  public popularList: Array<SelectItem> = [];
  public selectedPopular: ProductAttachments;

  public set isEditShow(value: boolean) {
    this.isEditDetails = value;
    this.isAddDetails = value;
  }
  
  public get isEditShow() {
    return this.isEditDetails || this.isAddDetails;
  }

  public get isAddShow() {
    return this.isAddDetails;
  }

  public set isAddShow(value: boolean) {
    this.isAddDetails = value;
  }


  // public get isImage() {
  //   return this.dataObj.doc_type;
  // }
  // public set isImage(value ='image') {
  //    this.dataObj.doc_type = value;
  // }
  public get dlgHeader() {
    return (this.isViewDetails ? 'View ' : (this.isEditDetails ? 'Edit ' : 'Add ')) + this.pageName;
  }

  /** grid columns and data fields */
  private columnsConfig: Array<GridHeaderEx> = [
    { field: 's_no', header: 'S No', isVisible: true, isDefault: true },
	  { field: 'attach_id', header: 'Id', isVisible: false, isDefault: true },
    // { field: 'country_code', header: 'Country', isVisible: true, isDefault: true },
    // { field: 'state_code', header: 'State', isVisible: true, isDefault: true },
    { field: 'prod_desc', header: 'Product', isVisible: true, isDefault: true },
    { field: 'attach_desc', header: 'ProductAttachments Name', isVisible: true, isDefault: true },
    { field: 'attach_name', header: 'ProductAttachments', isVisible: true, isDefault: true },
    { field: 'doc_type', header: 'ProductAttachments', isVisible: false, isDefault: true },
    // { field: 'prod_desc', header: 'ProductAttachments Description', isVisible: true, isDefault: true },
    { field: 'status', header: 'Actions', isVisible: true, isDefault: true },
  ];

  public get pageName() {
    return this.dataService.pageName;
  }

  constructor(
    private msgSvc: MsgService,
    public util: UtilService,
    private dataService: ProductAttachmentsService,
    private config: AppConfigService
  ) { }

  ngOnInit() {
    this.cols = this.columnsConfig.filter(i => i.isVisible)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });

    this.selectedColumns = this.columnsConfig.filter(i => i.isVisible && i.isDefault)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });
    this.dataService.getDataRecords();
    this.subscription.add(
      this.dataService.dataList.subscribe((data) => {
        this.dataArray = [];
        if (data.length) {
          this.dataArray = data.map((e, indx) => {
            e.s_no = indx + 1;
            return e;
          });
        } else {
          this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
        }
      }));
      this.dataService.getProducts()
      .subscribe(data => {
        this.productsList = data.map(ele => {
          return { label: ele.prod_desc, value: ele };
        });
      });

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }



	public fileUpload(event) {
		const file = event.target.files[0];
		this.dataObj.attach_name = file;
	}

  public viewImage(file: string) {
    return this.config.ipAddress + '/uploads/attachments/prod/' + file;
  }

  public viewPdf(file: string) {
    return this.config.ipAddress + '/uploads/attachments/prod/' + file;
  }

  public editData(event) {
    this.dataObj = Object.assign({}, event ? event : defaultProductAttachments);
    if (event == null) {
      this.isAddDetails = true;
    } else {
      this.isEditDetails = true;
	   this.bindDropDownList();
    }
  }
  private bindDropDownList() {

    if (this.dataObj.attach_type_id) {
      const item = this.productsList
        // tslint:disable-next-line: triple-equals
        .find(e => e.value.prod_id == this.dataObj.attach_type_id);
      this.selectedProduct = item ? item.value : undefined;
    }
    
  }

  public onProductChange(event) {
    this.dataObj.attach_type_id = (event.value as ProductMaster).prod_id;
  }
  
  public updateData() {
    if (this.isAddDetails) {
      this.createDetails();
    } else {
      this.updateCallType();
    }
  }

  public createDetails() {
    this.dataService.addData(this.dataObj).subscribe((data) => {
      if (data) {
        this.dataService.getDataRecords();
      }
    }, err => {
      this.msgSvc.addErrorMsg(err);
    });
    this.isAddDetails = false;
  }

  public cancelEditDlg() {
    this.isViewDetails = false;
    this.isAddDetails = false;
    this.isEditDetails = false;
  }

  public updateCallType() {
    this.dataService.updateData(this.dataObj).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isEditDetails = false;
  }

  public deleteDetails() {
    this.dataService.deleteData(this.dataObj.attach_id).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isDeleteDetails = false;
  }

  public deleteData(obj: ProductAttachments) {
    this.dataObj = obj;
    this.isDeleteDetails = true;
  }

  public viewData(obj: ProductAttachments) {
    this.dataObj = obj;
    this.isViewDetails = true;
  }

  public updateStatus(obj: ProductAttachments) {
    this.dataService.updateStatus(obj);
  }
}
